import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
const key = "b55d580200c51623fe9608f8f064a09b";

const MovieWatch = () => {
  const navigate = useNavigate();
  const [movieBgById, setMovieBgById] = useState("");

  const params = useParams();
  const [movieById, setMovieById] = useState("");
  const [videoId, setVideoId] = useState("");

  const getMovieBg = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/movie/${params.id}/images?api_key=${key}`
    );
    const data = response.data.backdrops[0];
    setMovieBgById(data.file_path);
  };

  const getMoviesById = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/movie/${params.id}?api_key=${key}&language=en-US`
    );
    const movieData = response.data;
    setMovieById(movieData);
  };

  const getVideoId = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/movie/${params.id}/videos?api_key=${key}&language=en-US`
    );
    setVideoId(response.data.results[0].key);
  };

  useEffect(() => {
    getMovieBg();
    getMoviesById();
    getVideoId();
  }, [params.id]);
  return (
    <>
      {videoId ? (
        <div
          className="watchMovie__container container-fluid d-flex flex-column align-items-start justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="d-flex align-items-center">
            <h4
              className="text-start fw-bold watchTitle mb-2 genreLink "
              onClick={() => navigate(`/pelicula/${movieById.id}`)}
              style={{ cursor: "pointer" }}
            >
              {movieById && movieById.title}
            </h4>
            <i
              className="ms-2 mb-1 fa-solid fa-play fa-lg"
              style={{ color: "#ee121de8" }}
            ></i>
          </div>
          <iframe
            className="frame"
            src={`https://www.youtube.com/embed/${videoId}`}
            width="100%"
            height="80%"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title={`video from ${movieById.title}`}
          />

          <Link
            to={`/pelicula/${movieById.id}`}
            onClick={() => window.scrollTo(0, 0)}
            style={{ textDecoration: "none", display: "inline" }}
          >
            <div
              className="backToMovie text-secondary d-flex align-items-center pt-3 ms-2"
              // onClick={() => navigate(`/watch/${movieById.id}`)}
            >
              <i className="fa-solid fa-arrow-left fa-sm pe-2 mt-1"></i>
              <span>Go back to Movie Page</span>
            </div>
          </Link>
        </div>
      ) : (
        <>
          <div
            className="loadingBg__watch d-flex align-items-center justify-content-center flex-column"
            style={{
              height: "100vh",
              width: "100%",
              backgroundImage: `url("https://image.tmdb.org/t/p/w500/${movieBgById}")`,
            }}
          >
            <div className="backToMovie text-secondary d-flex align-items-center pb-4 ms-2">
              <span>
                (If this is taking too long, is probably that there's no video
                abailable. Sorry!)
              </span>
            </div>
            <CircularProgress color="secondary" />
            <Link
              to={`/pelicula/${movieById.id}`}
              onClick={() => window.scrollTo(0, 0)}
              style={{ textDecoration: "none" }}
            >
              <div
                className="backToMovie text-secondary d-flex align-items-center pt-4 ms-2"
                // onClick={() => navigate(`/watch/${movieById.id}`)}
              >
                <i className="fa-solid fa-arrow-left fa-sm pe-2 mt-1"></i>
                <span>Go back to Movie Page</span>
              </div>
            </Link>
          </div>

          <div
            className="loadingBg__watch_res"
            style={{ height: "100vh", width: "100%", display: "none" }}
          >
            <CircularProgress color="inherit" />
            <Link
              to={`/pelicula/${movieById.id}`}
              onClick={() => window.scrollTo(0, 0)}
              style={{ textDecoration: "none" }}
            >
              <div
                className="backToMovie text-secondary d-flex align-items-center pt-3 ms-2"
                // onClick={() => navigate(`/watch/${movieById.id}`)}
              >
                <i className="fa-solid fa-arrow-left fa-sm pe-2 mt-1"></i>
                <span>Go back to Movie Page</span>
              </div>
            </Link>
          </div>
        </>
      )}
    </>
  );
};

export default MovieWatch;
